import { render } from "./px-questionary-currency-range.vue?vue&type=template&id=4a3025ab&scoped=true&ts=true"
import script from "./px-questionary-currency-range.vue?vue&type=script&lang=ts"
export * from "./px-questionary-currency-range.vue?vue&type=script&lang=ts"

import "./px-questionary-currency-range.vue?vue&type=style&index=0&id=4a3025ab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3025ab"]])

export default __exports__